import { PROJECTILE_RADIUS } from "./constants";
import { Box } from "./react-graphics";
import gunSound from "./pew1.mp3";
import useSound from "use-sound";
import { memo, useEffect } from "react";

type Props = {
  x: number;
  y: number;
};

const WIDTH = 2 * PROJECTILE_RADIUS;
const HEIGHT = 2 * PROJECTILE_RADIUS;

const PlayerProjectile = ({ x, y }: Props) => {
  const [playGunSound] = useSound(gunSound, { volume: 0.3 });
  useEffect(() => {
    playGunSound();
  }, [playGunSound]);
  return (
    <Box
      x={x}
      y={-y}
      width={WIDTH}
      height={HEIGHT}
      fillColor={0x000000}
      pivotX={0.5}
      pivotY={0.5}
    />
  );
};

export default memo(PlayerProjectile);
